module.exports = __webpack_public_path__ + "static/media/mae_logo.1b10d518.png";